import { ref } from 'vue';
import { Hotel } from './types/Hotel';
import { RawHotel as RawHotelType } from './types/RawHotel';

export { getSimilarHotels } from './api/similarHotelApi';
export { ISimilarHotel } from './types/similarHotels';
export { default as getColorNumber } from './lib/getColorNumber';
export { default as SimilarHotel } from './ui/SimilarHotel.vue';
export { Hotel, RenovationType } from './types/Hotel';
export { RawHotel } from './types/RawHotel';
export { default as mapHotel } from './lib/mapHotel';
export { default as getRenovationTypes } from './lib/getRenovationTypes';
export {
    ChildServiceId,
    ChildServiceOld,
    CHILD_SERVICE_OLD_MAP,
    RestTypeId,
    RestTypeOld,
    REST_TYPE_OLD_MAP,
    BeachTypeId,
    BeachTypeOld,
    BEACH_TYPE_OLD_MAP,
    IHotel,
} from './config/filterEnums';

export function useHotelsRepository() {
    return {
        hotels: ref<RawHotelType[]>([]),
    };
}
